import { memo, ReactNode, useEffect, useState } from "react";
import { Scrollbars } from "@tecorien/mimic-v2";
import classnames from "classnames";
import Modal from "react-modal";
import { Button } from "../Button";

import { ReactComponent as BackArrow } from "./icons/arrow-right.svg";

import styles from "./style.module.scss";

export type DrawerProps = {
  anchor?: string,
  title?: string,
  children?: ReactNode;
  isOpen: boolean,
  onRequestClose?: () => void;
} & Modal.Props

if (process.env.NODE_ENV !== "test") Modal.setAppElement("#root");

const Drawer = memo<DrawerProps>((
  {
    isOpen,
    onRequestClose,
    anchor = "right",
    title,
    children,
    overlayClassName,
    ...rest
  }) => {
  const [ hidden, setHidden ] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setHidden(false), 0);
    } else {
      setHidden(true);
    }
  }, [ isOpen ]);

  return (
    <Modal
      {...rest}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      closeTimeoutMS={300}
      overlayClassName={classnames(styles.overlay, overlayClassName as string)}
      className={classnames(
        styles.root,
        styles[anchor as any],
        { [styles.hidden]: hidden },
      )}
    >
      <div className={styles.header}>
        <Button
          onClick={onRequestClose}
          data-test="back-arrow"
          buttonType="round"
          buttonColorSchema="outlined-light"
        >
          <BackArrow width={24} height={24} />
        </Button>
        <div className={styles.title}>
          {title}
        </div>
      </div>
      <Scrollbars className={styles.scrollbar}>
        <div className={styles.content}>
          {children}
        </div>
      </Scrollbars>
    </Modal>
  );
});

export default Drawer;
